module.exports = __webpack_public_path__ + "828c65165b78a371ed7a5259d5c39f3b.png";